import EzloTool from './EzloTool';

export default EzloTool;
